(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-sticky-bar"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-sticky-bar')) {
    customElements.define(
      'product-sticky-bar',
      class ProductStickyBar extends HTMLElement {
        connectedCallback() {
          this.sectionId = this.dataset.sectionId;
          this.info = document.getElementById('ProductInfo-' + this.sectionId);
          this.buttonsWrap = this.info ? this.info.querySelector('.product-form__buttons') : null;
          this.mainPrice = document.getElementById('price-' + this.sectionId);
          this.stickyAtc = this.querySelector('[data-sticky-atc]');
          this.stickyBuy = this.querySelector('[data-sticky-buy-now]');
          this.stickyPrice = this.querySelector('[data-sticky-price]');

          this.bindClicks();
          this.observeVisibility();
          this.syncFromMain();
          this.observeMain();
        }

        disconnectedCallback() {
          if (this.visObserver) this.visObserver.disconnect();
          if (this.mainObserver) this.mainObserver.disconnect();
        }

        realAtc() {
          return document.getElementById('ProductSubmitButton-' + this.sectionId);
        }

        realBuy() {
          return this.info ? this.info.querySelector('[data-buy-now]') : null;
        }

        bindClicks() {
          if (this.stickyAtc) {
            this.stickyAtc.addEventListener('click', () => {
              const real = this.realAtc();
              if (real) real.click();
            });
          }
          if (this.stickyBuy) {
            this.stickyBuy.addEventListener('click', () => {
              const real = this.realBuy();
              if (real) real.click();
            });
          }
        }

        observeVisibility() {
          if (!this.buttonsWrap || !('IntersectionObserver' in window)) return;
          this.visObserver = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                this.classList.toggle('is-visible', !entry.isIntersecting);
              });
            },
            { threshold: 0 }
          );
          this.visObserver.observe(this.buttonsWrap);
        }

        observeMain() {
          if (!this.info || !('MutationObserver' in window)) return;
          this.mainObserver = new MutationObserver(() => this.syncFromMain());
          this.mainObserver.observe(this.info, {
            subtree: true,
            childList: true,
            characterData: true,
            attributes: true,
            attributeFilter: ['disabled', 'class'],
          });
        }

        syncFromMain() {
          this.mainPrice = document.getElementById('price-' + this.sectionId);
          if (this.mainPrice && this.stickyPrice) {
            this.stickyPrice.innerHTML = this.mainPrice.innerHTML;
          }
          const real = this.realAtc();
          if (real && this.stickyAtc) {
            const unavailable = real.hasAttribute('disabled');
            this.stickyAtc.disabled = unavailable;
            const label = real.querySelector('.product-form__submit-text');
            if (label) this.stickyAtc.textContent = label.textContent.trim();
          }
          const buy = this.realBuy();
          if (this.stickyBuy) {
            this.stickyBuy.style.display = buy ? '' : 'none';
          }
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
